export default "__VITE_ASSET__BXD4iXL4__"